/** @jsxImportSource @emotion/react */

import { useRef } from 'react'

import IDSSwitcherFilter from './IDSSwitcherFilter'
import IDSSwitcherOption from './IDSSwitcherOption'
import SwitcherStyle from './IDSSwitcherStyle'

const IDSSwitcherList = ({
  setShowDropdownFilter,
  showDropdownFilter,
  isSwitcherActive,
  tenantsIncluded,
}) => {
  const parseUrl = window.location.host.split('.')
  const tenant = parseUrl[0].replace(/-/g, '_')

  const tenantsForDisplay = tenantsIncluded.filter(
    item => item.attributes.identifier !== tenant
  )
  const refContainer = useRef(null)

  let switcherActiveStyle = isSwitcherActive
    ? SwitcherStyle.tenantSwitcherActive
    : SwitcherStyle.tenantSwitcherInActive

  const handleFilter = () => {
    if (refContainer.current) {
      const isInputFocused =
        document.getElementById('filter-input') === document.activeElement
      if (!isInputFocused) {
        refContainer.current.style.display = 'none'
        setShowDropdownFilter(false)
      }
    }
  }
  return (
    <div
      data-testid="tenant-switcher-list"
      id="tenant-switcher-list"
      css={[SwitcherStyle.tenantSwitcherList, switcherActiveStyle]}
      onClick={handleFilter}
    >
      <div css={SwitcherStyle.tenantSwitcherFilterWrapper}>
        <IDSSwitcherFilter
          refContainer={refContainer}
          setShowDropdownFilter={setShowDropdownFilter}
          showDropdownFilter={showDropdownFilter}
          tenantsIncluded={tenantsIncluded}
        />
      </div>

      <div css={SwitcherStyle.switcherOption}>
        {tenantsForDisplay?.map(({ attributes }, key) => (
          <IDSSwitcherOption key={key} {...attributes} tenant={tenant} />
        ))}
      </div>
    </div>
  )
}

export default IDSSwitcherList
